module.exports = __webpack_public_path__ + "media/images/city/018-id-kah-mosque-816d15709e2f08d7d5a8cc45e15f3347.svg";